import { AppState, UserState } from '@d-store/constant';
import { createSelector } from '@ngrx/store';

const currentUser = (state: AppState) => state.currentUser;

export const getCurrentUser = createSelector(
  currentUser,
  (state: UserState) => state,
);

export const getCurrentUserLevel = createSelector(
  currentUser,
  (state: UserState) => state.level,
);

export const getCurrentTenant = createSelector(
  currentUser,
  (state) => state.currentTenant,
);
